<template>
    <section v-if="hasPermissions(['Days-Off-Template Read', 'Days-Off-Template Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Templates for Days Off. Select the Template from the dropdown list. Click Add Associate to add a name to the Template. Choose the Associate name and select the Assignment for each day of the Template.
            </p>
        </div>

        <div class="bar-container-schedule" style="margin-bottom: 19px;">
            <div class="bar-container-schedule__search-bar" v-if="Object.keys(parent).length">
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div v-for="(key, index) in rotation_form_format" :key="index" class="bar-container-schedule__rotation">
                <select
                    :disabled="key.disabled"
                    :multiple="key.type === 'select-multiple' ? true : false"
                    :size="key.maxlength"
                    class="form-control custom-select"
                    :style="`font-size:12px; ${key.type === 'select-multiple' ? '' : 'height: 32px;'}`"
                    :required="key.required"
                    v-model="rotation_data[key.model_name]"
                    @change="searchTemplate(rotation_data[key.model_name])"
                >
                    <option value='' v-html="'Select Rotation Template'"/>
                    <option v-for="(value, i) in array_options[key.model_name]" :key="i" :value="value.decrypted_id" v-html="value.name"/>
                </select>
                </div>
            <div class="bar-container-schedule__options">
                <div v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Template Write'])"
                    class="btn-group modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2"
                    style="margin-top:-2px;">
                    <button type="button"
                        style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;"
                        v-html="'Delete Options'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                    <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false"
                        style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                        <a class="dropdown-item" href="#" @click="massive_modal_delete(false)" v-html="'Mass Delete'" disabled/>
                        <a class="dropdown-item" href="#" @click="massive_modal_delete(true)" v-html="'Delete All'" />
                    </div>
                </div>
                <button v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Template Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'master_days_off_template_file'"
                    @data="uploadData($event)"
                    v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Template Write'])"
                />
                <button  class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2"  @click="printTemplate()" v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Template Read'])">Print</button>
            </div>
            <div class="bar-container-schedule__cta" v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Template Write'])">
                <span class="button__modal text-md-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>
        <Indications />
        <!-- <div class="row mb-0 no-gutters templates__grid" v-if="Object.keys(parent).length && has_permission('Days-Off-Template Read-Write')"> -->
        <div class="row mb-0 no-gutters templates__grid" v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Template Read'])">
            <div class="templates__grid__tabs">
                <div id="nav-tab" role="tablist" class="nav nav-tabs templates__grid__item d-flex justify-content-between">
                    <a class="templates__grid__tabs__item rounded active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" v-html="'View by Associate'" style="text-align:center;" @click="view_by_associate = true"/>
                    <a class="templates__grid__tabs__item rounded" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false" v-html="'View by Assignment'" style="text-align:center;" @click="view_by_associate = false"/>
                </div>
            </div>
        </div>
        <div class="shadow-sm p-2 mb-5 bg-white rounded mt-4" v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Template Read'])">
            <div class="row justify-content-center" id="multiselect__filter" v-if=" Object.keys(parent).length">
                <div class="col-md-12">
                    <multiselect v-model="filtered_items" :options="filtered_options" :multiple="true" :close-on-select="false" :clear-on-select="false" :taggable="true" :preserve-search="true" :placeholder="`Filter by ${(view_by_associate) ? 'associate' : 'daily assignment' }`" label="name" track-by="name" :preselect-first="true">
                        <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen" >{{ values.length }} {{ (view_by_associate) ? 'Associate(s)' : 'Daily assignment(s)' }} selected</span></template>
                    </multiselect>
                </div>
            </div>
        </div>
        <ScheduleTable
            :parent="parent"
            :form_data="form_data"
            :schedules="templates"
            :view_by_associate="view_by_associate"
            :editable="true"
            :prior_start_date="prior_start_date"
            @setNewAssignment="setNewAssignment($event)"
            @setMainAssignment="setMainAssignment($event)"
            @setNewAssociate="setNewAssociate($event)"
            @setAssociates="setAssociates($event)"
            used_in="templates"
            ref="schedule_table"
        />

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Master days off'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :parent="parent"
            :rotation="rotation_data"
            :form_data="form_data"
            :form_backup="form_backup"
            :array_options="array_options"
            :schedule_options="schedule_options"
            :daily_assignment_options="daily_assignment_options"
            @unshiftObject="unshift_object($event)"
            :used_in="'master_days_off'"
        />

        <FormModalAssignment 
            :title="'Set Daily Assignment'"
            :breadcrumb="breadcrumb"
            :rest_api="ext_rest_api"
            :notyf="notyf"
            :parent="parent"
            :templates="templates"
            :single_object="template_object"
            :template_index="template_index"
            :schedule_index="schedule_index"
            :array_options="array_options"
            :view_by_associate="view_by_associate"
            :indexes="indexes"
            @spliceObject="splice_template_object($event)"
            ref="modalAssignment"
            :parent_rest_api="rest_api"
        />

        <FormModalAssociate 
            :title="'Set Associate'"
            :breadcrumb="breadcrumb"
            :rest_api="associate_rest_api"
            :parent="parent"
            :templates="templates"
            :indexes="indexes"
            :notyf="notyf"
            :single_object="template_object"
            :template_index="template_index"
            :schedule_index="schedule_index"
            :array_options="array_options"
            :view_by_associate="view_by_associate"
            @spliceObject="splice_template_object($event)"
            ref="modalAsssociate"
        />

        <UploadSummary 
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="name_file_summary"
        />
        <HelperModal :helps="helps"/>

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb           from '@/components/BreadcrumbComponent/Breadcrumb'
import DeletionMassiveModal from '@/components/DeletionMassiveModal'
import WaitingModal         from '@/components/WaitingModal'
import Resources            from './resources'
import FormResources        from './form_resources'
import FormModal            from '@/components/DayOffComponent/Schedule/FormModal'
import FormModalAssignment  from './FormModalAssignment'
import DeletionModal        from '@/components/DeletionModal'
import FormModalAssociate  from './FormModalAssociate'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import ScheduleTable         from    '../Schedule/ScheduleTable'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import HelperModal           from    '@/components/HelperModal'
import Indications from '../Schedule/Indications.vue'
import 'vuetify/dist/vuetify.min.css'
import { Notyf }            from 'notyf'
import 'notyf/notyf.min.css'; // for React and Vue
import Multiselect  from    "vue-multiselect"

const notyf = new Notyf({
    duration: 8000,
});
export default {
    
    name: 'Template',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        FormModalAssignment,
        DeletionMassiveModal,
        Multiselect,
        UnauthorizedComponent,
        ScheduleTable,
        FormModalAssociate,
        UploadOptions,
        UploadSummary,
        Indications,
        HelperModal
    },

    data() {
        return {
            notyf,
            title_page:       'Master Days Off',
            rest_api:         `templates`,
            ext_rest_api:     `template_set_assignment`,
            associate_rest_api: `template_set_associate`,
            table_headers:    Resources.table_headers,
            breadcrumb:       Resources.breadcrumb,
            excel_file_headers: {},
            empty_format_data:  Resources.empty_format_data,
            // schedule_options: Resources.schedule_options,

            /** */
            rotation_form_format:      FormResources.rotation_form_format,
            rotation_data:             FormResources.rotation_data,
            schedule_options:          FormResources.schedule_options,
            daily_assignment_options:  [],
            daily_assignment_position: [],
            /** */

            form_data:   FormResources.form_data,
            form_backup: {...FormResources.form_data},

            add_btn:           'Add Associate',
            single_select:     false,
            table_selection:   [],
            search:            '',

            global_index:      null,
            template_index:    null,
            schedule_index:    null,

            single_object:     {},
            template_object:   {},

            parent:            {},
            templates:         [],
            daily_assignments: [],
            date_circuit:      [],
            array_options:     {},
            schedule_header:   [],
            select_ids:        [],
            massive_all:        false,
            filtered_items:    [],
            filtered_options:   [],
            indexes: {},
            name_file_summary: 'live_schedules_failed_template_file',
            summary: [],
            excel_data: [],
            view_by_associate: true,
            prior_start_date: null,
            clean_all: false,
            helps: Resources.helps

        }
    },

    computed:
    {
        selected()
        {
            const bool = this.templates.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },

    watch:
    {
        filtered_items()
        {
            this.templates.map(template => 
            {
                if(this.view_by_associate)
                {
                    if(template.associate_id)
                    {
                        if(this.filtered_items.find(associate => associate.id === template.associate_id))
                        {
                            template.show = true
                        }
                        else
                        {
                            template.show = false
                        }
                    }
                }
                else
                {
                    if(template.daily_assignment_id)
                    {
                        if(this.filtered_items.find(daily_assignment => daily_assignment.id === template.daily_assignment_id))
                        {
                            template.show = true
                        }
                        else
                        {
                            template.show = false
                        }
                    }
                }
            })
        },

        massive_all(val)
        {
            this.templates.map(item => item.checked = val)
        },

        async 'view_by_associate'()
        {
            await this.graphic_table_data(this.rotation_data.rotation_setup_id)
        }

    },

    methods: {
        async printTemplate()
        {
            this.loader(true)
            const response = await this.post(`${this.rest_api}/reports/template`, { id:  this.parent.id, view_by_associate: this.view_by_associate})
            this.loader()

            if(response.status)
            {
                this.downloadReport(response)
            }
            else
            {
                this.error_handling(response)
            }
        },

        async settingUploadOptions(schedule_header)
        {
            this.excel_file_headers = {...Resources.excel_file_headers}
            schedule_header.forEach((item, index) => {
                const complete_header = `${index + 1} - ${item.name}`
                this.excel_file_headers[complete_header] = complete_header
            });
        },

        massive_modal_delete(clean_all)
        {
            this.clean_all = clean_all
            
            if(!clean_all)
            {
                let local_ids = this.templates.filter(item => item.checked) 
                
                if(local_ids.length)
                {
                    if(this.view_by_associate)
                    {
                        this.select_ids = local_ids.map(item => item.id)
                    }
                    else
                    {
                        this.select_ids = local_ids.map(item => item.daily_assignment_id)
                    }

                    window.$('#static-deletion-massive').modal('show')
                }
                else
                {
                    this.notyfMesg('No items selected', 'error')
                }
            }
            else
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive;

            if(this.clean_all)
            {
                sendingMassive = await this.cleanAll()
            }
            else
            {
                let json_request = {
                    ids: this.select_ids,
                    rotation_id: this.parent.id,
                    view_by_associate: this.view_by_associate,
                }

                sendingMassive = await this.massive_delete(json_request)
            }

            if(sendingMassive)
            {
                await this.graphic_table_data(this.rotation_data.rotation_setup_id)
                this.select_ids = []
                this.massive_all = false
            }
        },

        splice_template_object()
        {
            this.graphic_table_data(this.rotation_data.rotation_setup_id);
            window.$('#static-assignment').modal('hide')
            window.$('#static-associate').modal('hide')
        },

        setNewAssignment({index, index_item, date_for_backend})
        {
            if(this.hasPermissions(['Days-Off-Template Write']))
            {
                this.indexes = {row_index: index, item_index: index_item}
                
                this.template_object = {...this.templates[index].rotation_day_assignments[index_item]}
                let is_time_off = (this.template_object.assignments[0] && this.template_object.assignments[0].is_time_off) ? true : false;
                this.$refs.modalAssignment.reset(is_time_off, this.template_object, date_for_backend);
                window.$('#static-assignment').modal('show')
            }
        },

        setMainAssignment(index)
        {
            if(this.hasPermissions(['Days-Off-Template Write']))
            {
                this.indexes = {row_index: index}
                this.template_object = {...this.templates[index]}
                this.template_object['rotation_id'] = this.parent.encrypt_id

                this.$refs.modalAssignment.reset(false, this.template_object);
                window.$('#static-assignment').modal('show')
            }

        },

        setAssociates({index, index_item})
        {
            if(this.hasPermissions(['Days-Off-Template Write']))
            {
                this.indexes = {
                    row_index: index,
                    item_index: index_item
                }

                this.template_object = {...this.templates[index].rotation_day_assignments[index_item]}
                this.template_object['rotation_id'] = this.parent.encrypt_id;
                this.$refs.modalAsssociate.reset(this.template_object);
                window.$('#static-associate').modal('show')
            }
        },

        setNewAssociate(index)
        {
            if(this.hasPermissions(['Days-Off-Template Write']))
            {
                this.indexes = {row_index: index}
                this.template_object = {...this.templates[index]}
                this.template_object['rotation_id'] = this.parent.encrypt_id
                window.$('#static-associate').modal('show')
            }
        },

        async graphic_table_data(rotation_id)
        {
            this.invoke_loader('get')

            const http_request = {
                id: rotation_id,
                view_by_associate: this.view_by_associate
            }

            const response = await this.post(`${this.rest_api}/search_template`, http_request)

            this.revoke_loader('get')

            if(response.status)
            {
                this.massive_all = false

                this.parent = response.data.data.rotation_setup

                this.templates = response.data.data.templates

                this.prior_start_date = response.data.prior_start_date

                this.filtered_options = this.templates.map(item =>
                    {
                        if(this.view_by_associate)
                        {
                            return {id: item.associate_id, name: item.associate}
                        }

                        return {id: item.daily_assignment_id, name: item.daily_assignment}
                    })
                    
                this.filtered_items = this.filtered_options;
                
                if(this.parent)
                {
                    this.rotation_data.rotation_setup_id = rotation_id

                    this.$router.replace({ 
                        path: 'days-off-templates', 
                        query: { 
                            schedule_id: rotation_id
                        }
                    }).catch(()=> {})
                }
            }
            else
            {
                this.error_handling(response)
            }

            await this.$refs.schedule_table.scheduleFormatIncrease()

            this.settingUploadOptions(this.$refs.schedule_table.schedule_header)
        },

        async unshift_object()
        {
            let form_data = {...this.form_backup}
            form_data.new_associates = []
            this.form_data = form_data
            await this.graphic_table_data(this.rotation_data.rotation_setup_id)
        },

        splice_object(splicing_object)
        {
            this.templates.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.templates[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.templates[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.templates     = []
            this.array_options = {
                rotation_setup_id: data.rotation_setups,
                associate_id: data.associates,
                supervisor_id: data.supervisors,
                daily_assignment_id: data.assignemnts,
                time_off_id: data.time_offs
            }
            this.daily_assignment_options = data.assignemnts
        },

        async searchTemplate(rotation_id)
        {
            if(rotation_id)
            {
                this.templates = []
                this.daily_assignments = []

                if(this.hasPermissions(['Days-Off-Template Read']))
                {
                    await this.graphic_table_data(rotation_id)
                }
            }
            
        },

        async uploadData(data)
        {
            this.excel_data = data

            this.loader(true)
            const response = await this.put(`${this.rest_api}/massive/${this.$route.query.schedule_id}`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.excel_file_headers = Resources.excel_file_headers
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                await this.graphic_table_data(this.rotation_data.rotation_setup_id)
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
        },

        trashing(index)
        {
            this.templates.splice(index, 1)
        },

        async cleanAll()
        {
            const response = await this.massive_delete({rotation_setup_id: this.parent.id, clean_all: true})

            if(response.status)
            {
                this.notyfMesg('Schedule was cleaned')
            }
            else
            {
                this.error_handling(response)
            }

            return true;
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['Days-Off-Template Read', 'Days-Off-Template Write']))
        {
            await this.api_request()
        }

        if(this.$route.query.schedule_id)
        {
            await this.graphic_table_data(this.$route.query.schedule_id)
        }
    }

}
</script>
